import config from 'global-variables';
import { useMutation, useQueryClient } from 'react-query';
import { getToken } from './useLogin';
import { User } from '../types/User';

async function createUser({ user }: { user: User }) {
    const token = getToken();
    if (!token || !user) return null;
    const host = config.restAPIUrl;
    const res = await fetch(`${host}/admin/users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(user),
    });
    if (!res.ok) {
        const txtRes = await res.text();
        throw new Error('Error creating user: ' + txtRes);
    }
    const data = await res.json();
    return data;
}

export function useCreateUser() {
    const queryClient = useQueryClient();
    return useMutation((user: User) => createUser({ user }), {
        onSuccess: () => {
            queryClient.invalidateQueries(['users-list']);
        },
    });
}
